import React, { useState } from 'react';
import axios from 'axios';
import apis from "../assets/js/apis.js";
import { useMst } from '../models/root';
import { observer } from "mobx-react-lite";

const NominationCard = observer((props) => {
    const {variables} = useMst()
    const [nominated,setNominated]=useState(false);

    const runAPI = async () => {
        const options = {
            headers: {'Authorization': `Bearer ${variables.access_token}`}
          };
          return axios.post(apis.addidea,{"nominated_id":props.id},options)
    }
    
    const handleClick = (event) =>{
        if(props.dummy){
            if(nominated==false){
            setNominated(true);
            setTimeout(()=>{
                setNominated(false)
            },1000)
        }
        }
        else {
            if(nominated==false){
                runAPI().then((result)=>{
                    if (result.data.success == 1)
                    {
                        setNominated(true);
                        setTimeout(()=>props.makeNominated(props.id),1500);
                    }
                });
            }
        }
    }


    return (
        <div class="relative m-auto my-2 h-20 w-10/12">
            <div class="flex float-left items-center w-4/12">
                <div class="w-16 h-16"><img src={props.img} alt={props.name}/></div>
            </div>
            <div class="relative p-0.5 float-left w-8/12">
                
                    <p>{props.name}</p>
                    <p class="text-gray-500 text-sm">{props.email}</p>
                    {!nominated&&<div onClick={handleClick} class="w-7/12 text-white rounded text-center m-1 font-light bg-blue-700">
                        <p class="pt-0.25">Nominate</p>
                    </div>}
                    {nominated&&<div class="w-7/12 text-blue-700 rounded text-center m-1 font-light">
                        <p class="pt-0.25">{props.dummy?"Dummy!":"Nominated"}</p>
                    </div>}
              
            </div>
        </div>
    );
})

export default NominationCard;